module.exports = __webpack_public_path__ + "static/logistics-a1b68d84a29c569b825985669c540958.png";